import React, { Component } from 'react';
import { Table, TableColumnType } from '../table/Table';
import { UserContext, documentPropNames, documentBpActions, alfrescoTypes } from '../../constants';
import { hideModalDialog, showModalDialog } from '../ModalDialog';
import { getFilesContentForSigning, submitSignedFile, executeSubmitRequest } from '../documents/DocumentHelpers';
import { SignForm } from './SignForm';
import * as ModalDialogsTemplates from '../ModalDialog'
import i18next from "../../i18n";

const tableSettings = {
    name: "batchSignFormTable",
    columns: [
        {
            "id": "0",
            "name": "Id",
            "headerName": "",
            "type": TableColumnType.String,
            "hidden": true
        },
        {
            id: "1",
            name: "documentName",
            headerName: i18next.t("batchSignForm.cols.documentName"),
            type: TableColumnType.String
        },
        {
            id: "2",
            name: "signCount",
            headerName: i18next.t("batchSignForm.cols.signCount"),
            type: TableColumnType.String
        },
        {
            id: "3",
            name: "notSigningReason",
            headerName: i18next.t("batchSignForm.cols.notSigningReason"),
            type: TableColumnType.ColoredString,
            showFalseValue: true
        },
        {
            id: "4",
            name: "notSendReason",
            headerName: i18next.t("batchSignForm.cols.notSendReason"),
            type: TableColumnType.ColoredString,
            showFalseValue: true
        }
    ]
}

export class BatchSignForm extends Component {
    static contextType = UserContext;

    docForms = {};

    constructor(props) {
        super(props);

        this.state = {
            docIds: props.docIds,
            checkedList: [],
            lastOperationCheckedList: [],
            tableItems: [],
            docProps: [],
            dateLoaded: null,
            loaded: false,
            wasSent: false
        };

        this.getDocuments = this.getDocuments.bind(this);
        this.onClose = this.onClose.bind(this);
        this.onCheckChanged = this.onCheckChanged.bind(this);
        this.onSend = this.onSend.bind(this);
        this.onSign = this.onSign.bind(this);
        this.loadDocuments = this.loadDocuments.bind(this);
        this.checkIsDocumentsActual = this.checkIsDocumentsActual.bind(this);
        this.getSendAction = this.getSendAction.bind(this);
        this.index = 0;
        this.loadDocuments();
    }

    loadDocuments() {
        this.getDocuments(this.state.docIds).then(data => {
            if (data && data.resultDocs) {
                let tableItems = [];
                let docProps = [];
                data.resultDocs.forEach(doc => {
                    let props = JSON.parse(doc.documentProps);
                    tableItems.push(this.getTableItem(doc, props));
                    props.attachments = doc.attachments;
                    props.documentType = doc.documentType;
                    props.associations = doc.associations;
                    docProps[props[documentPropNames.id]] = props;
                });
                let actualIds = this.state.docIds.filter(id => tableItems.some(it => it.columns.Id === id));
                let actualcheckedList = this.state.checkedList.filter(id => tableItems.some(it => it.columns.Id === id));

                tableItems.sort((item1, item2) => item1.columns.documentName > item2.columns.documentName ? 1 : -1);

                this.setState({
                    docIds: actualIds,
                    checkedList: actualcheckedList,
                    tableItems: tableItems,
                    docProps: docProps,
                    dateLoaded: data.dateLoaded,
                    loaded: true
                }, () => {
                    if (this.state.wasSent) this.showDocumentSending(actualIds);
                });
            }
        });
    }

    getTableItem(doc, props) {
        this.index++;

        return {
            columns: {
                Id: props[documentPropNames.id],
                documentName: props[documentPropNames.title],
                notSigningReason: { text: doc.notAllowedSignReason ? doc.notAllowedSignReason : i18next.t("batchSignForm.messages.noReason"), color: doc.canSign ? "#008000" : "#bf301a" },
                notSendReason: { text: doc.notAllowedSendReason ? doc.notAllowedSendReason : i18next.t("batchSignForm.messages.noReason"), color: doc.canSend ? "#008000" : "#bf301a" },
                signAbility: doc.canSign,
                sendAbility: doc.canSend,
                signCount: doc.signCount.toFixed()
            }
        }
    }

    async getDocuments(docIds) {
        let data = null;
        if (docIds) {
            data = await fetch('/Document/GetBatchOperationInfos', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(docIds)
            })
                .then(async response => {
                    if (response.ok) {
                        let result = await response.json();
                        return result;
                    }
                });
        }
        if (data.errorCode != 0) {
            ModalDialogsTemplates.messageDialog(i18next.t("error"), i18next.t(`batchSignForm.errors.${data.errorCode}`), () => { }, 'modalSubDialog');
        }
        return data;
    }

    async checkIsDocumentsActual(docIds) {
        let result = false;
        if (docIds) {
            const data = await fetch(`/Document/CheckIsDocumentsActual?loadedDate=${this.state.dateLoaded}`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(docIds)
            })
                .then(async response => {
                    if (response.ok) {
                        let result = await response.json();
                        return result;
                    }
                    else {
                        return false;
                    }
                });
            if (data.notActualDocIds?.length === 0) result = true;
        }
        return result;
    }

    onClose() {
        if (this.props.onClose)
            this.props.onClose();
    }

    onCheckChanged(checkedList) {
        this.setState({ checkedList: checkedList });
    }

    getSendAction(id) {
        switch (this.state.docProps[id].documentType) {
            case alfrescoTypes.contract: {
                return documentBpActions.activiti$completeContractsSigning;
            }
            case alfrescoTypes.counterpartyDoc: {
                return documentBpActions.activitiProcessDocCA;
            }
        }
    }

    async onSend() {
        const { checkedList } = this.state;

        const isActual = await this.checkIsDocumentsActual(checkedList);

        if (isActual) {
            let message = i18next.t("batchSignForm.messages.docsSuccessfullySended");
            let errorMessage = i18next.t("batchSignForm.messages.batchSendError");
            let hasErrors = false;
            let sentDocs = [];

            

            const response = await fetch("Document/BatchSending", {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(checkedList)
            });
            if (!response.ok) {
                ModalDialogsTemplates.unknownErrorMessageDialog();
                this.setState({ wasSent: false, sentDocs: [] }, () => this.loadDocuments());
            }
            else {
                const errorDocs = await response.json();
                for (const id of checkedList) {
                    if (errorDocs?.includes(id)) {
                        hasErrors = true;
                    }
                    else {
                        sentDocs.push(id);
                    }
                }
            }

            if (!hasErrors) {
                ModalDialogsTemplates.messageDialog(i18next.t("done"), message, () => {
                    this.setState({ wasSent: true, sentDocs }, () => this.loadDocuments());
                }, 'modalSubDialog');
            }
            else {
                ModalDialogsTemplates.messageDialog(i18next.t("error"), errorMessage, () => {
                    this.setState({ wasSent: true, sentDocs }, () => this.loadDocuments());
                }, 'modalSubDialog');
            }
        }
        else {
            ModalDialogsTemplates.messageDialog(i18next.t("error"), i18next.t("batchSignForm.messages.batchNotActualDocsError"), () => this.loadDocuments(), 'modalSubDialog');
        }
    }

    async onSign() {
        const { checkedList, docProps } = this.state;

        let message = i18next.t("batchSignForm.messages.docsSuccessfullySigned");
        let errorMessage = i18next.t("batchSignForm.messages.batchSignError");
        let hasErrors = false;

        let isActual = await this.checkIsDocumentsActual(checkedList);

        if (isActual) {
            let idList = checkedList.map(id => id);
            checkedList.forEach(id => {
                if (docProps[id].associations?.additionalDocuments?.length > 0) {
                    idList.push(...docProps[id].associations?.additionalDocuments);
                }
            });
            let fielesContent = await getFilesContentForSigning(idList, true);
            if (fielesContent) {
                if (fielesContent.length < idList.length) {
                    hasErrors = true;
                }
                let showResult = () => {
                    if (!hasErrors) {
                        ModalDialogsTemplates.messageDialog(i18next.t("done"), message, () => { this.loadDocuments(); }, 'modalSubDialog');
                    }
                    else {
                        ModalDialogsTemplates.messageDialog(i18next.t("error"), errorMessage, () => { this.loadDocuments(); }, 'modalSubDialog');
                    }
                }
                let onSignHandler = async (signs) => {
                    isActual = await this.checkIsDocumentsActual(checkedList);
                    if (isActual) {
                        for (let j = 0; j < signs.length; ++j) {
                            let isSuccessResult = await submitSignedFile(signs[j]);
                            hasErrors = hasErrors || !isSuccessResult;
                        }
                        showResult();
                    }
                    else {
                        ModalDialogsTemplates.messageDialog(i18next.t("error"), i18next.t("batchSignForm.messages.batchNotActualDocsError"), () => { this.loadDocuments(); }, 'modalSubDialog');
                    }
                }

                if (fielesContent.length > 0) {
                    showModalDialog('modalSubDialog', i18next.t("digitalSignature"), "",
                        <SignForm files={fielesContent}
                            onSignHandler={onSignHandler.bind(this)}
                            onCloseHandler={() => { hideModalDialog('modalSubDialog'); }}
                            errorDialogId="modalSubDialog"
                            notShowError={true}
                            handlerError={() => {
                                ModalDialogsTemplates.messageDialog(i18next.t("error"),
                                    i18next.t("batchSignForm.messages.batchSignError"),
                                    () => { this.loadDocuments(); }, 'modalSubDialog')
                            }
                            }
                        />,
                        "feedPopup middle-size", true, [], () => { hideModalDialog('modalSubDialog'); });
                }
                else
                    showResult();
            }
            else {
                ModalDialogsTemplates.messageDialog(i18next.t("error"), i18next.t("batchSignForm.messages.batchSignLoadDocumentsError"), () => { this.loadDocuments(); }, 'modalSubDialog');
            }
        }
        else {
            ModalDialogsTemplates.messageDialog(i18next.t("error"), i18next.t("batchSignForm.messages.batchNotActualDocsError"), () => { this.loadDocuments(); }, 'modalSubDialog');
        }
    }

    showDocumentSending(docs) {
        let { docIds, checkedList, sentDocs, tableItems, docProps } = this.state;

        let wasSentFromChecked = docs.filter(id => sentDocs.includes(id));
        docIds = docIds.filter(id => !wasSentFromChecked.includes(id));
        tableItems = tableItems.filter(it => !wasSentFromChecked.includes(it.columns.Id));
        wasSentFromChecked.forEach(id => {
            delete docProps[id];
            const rowId = 'table_row_' + id;
            const row = document.getElementById(rowId);
            if (row) {
                row.classList.add('sending');
                row.classList.remove('active');
            }
        });
        checkedList = checkedList.filter(id => !wasSentFromChecked.includes(id));;
        setTimeout(() => {
            this.setState({ docIds: docIds, tableItems: tableItems, docProps: docProps, checkedList: checkedList, sentDocs: [], wasSent: false });
        }, 500);
    }


    render() {
        const { tableItems, checkedList, loaded, wasSent } = this.state;
        const canSign = checkedList.length > 0 && !tableItems.some(item => checkedList.includes(item.columns.Id) && !item.columns.signAbility);
        const canSend = checkedList.length > 0 && !tableItems.some(item => checkedList.includes(item.columns.Id) && !item.columns.sendAbility);

        return (
            <>
                <div className="modal-body scrollYInner">
                    {tableItems.length > 0 && <Table name={tableSettings.name} columns={tableSettings.columns} items={tableItems} onCheckChangeHandler={this.onCheckChanged} />}
                    {loaded && tableItems.length === 0 && <div className="batch-not-found" style={{ textAlign: "center" }} >{i18next.t("batchSignForm.messages.batchDocumentsNotFound")}</div>}
                </div>
                <br />
                <div className="modal-footer">
                    <div className="form-group form-group__last">
                        {canSign && !wasSent ? <button type="button" className="btn btn-primary" onClick={() => this.onSign(false)}>{i18next.t("batchSignForm.batchSignBtn")}</button> :
                            <button type="button" className="btn btn-primary" disabled="disabled">{i18next.t("batchSignForm.batchSignBtn")}</button>
                        }
                        {canSend && !wasSent ? <button type="button" className="btn btn-primary" onClick={this.onSend}>{i18next.t("sendTo")}</button> :
                            <button type="button" className="btn btn-primary" disabled="disabled">{i18next.t("sendTo")}</button>
                        }
                        <button type="button" className="btn btn-secondary" onClick={this.onClose} >{i18next.t("close")}</button>
                    </div>
                </div>
            </>
        );
    }
}